/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_Sign_Reset_Password_Missing_TokenInputs */

const en_common_sign_reset_password_missing_token = /** @type {(inputs: Common_Sign_Reset_Password_Missing_TokenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Missing reset token. Please open the link from your email.`)
};

const zh_common_sign_reset_password_missing_token = /** @type {(inputs: Common_Sign_Reset_Password_Missing_TokenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`缺少重置令牌，请从邮件中打开链接。`)
};

/**
* | output |
* | --- |
* | "Missing reset token. Please open the link from your email." |
*
* @param {Common_Sign_Reset_Password_Missing_TokenInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const common_sign_reset_password_missing_token = /** @type {((inputs?: Common_Sign_Reset_Password_Missing_TokenInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_Sign_Reset_Password_Missing_TokenInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_common_sign_reset_password_missing_token(inputs)
	return zh_common_sign_reset_password_missing_token(inputs)
});
export { common_sign_reset_password_missing_token as "common.sign.reset_password_missing_token" }